import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent } from '@fuse';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Input, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';

import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import ItemAdder from "main/content/sales/billing/itemAdder";
import { withAlert } from 'react-alert';
import CloseIcon from '@material-ui/icons/Close';
import Select from 'react-select';
import moment from 'moment';
import 'react-select/dist/react-select.css'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import { AppBar, Icon, IconButton, Toolbar } from 'material-ui';
import printjs from 'print-js';

const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0,
        width: "100%",
        textAlign: "right",
        fontSize: '1.8rem'
    }
});

class JournalEntry extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            ledgerAccounts: [],
            ledgerAccountNames: [],
            ledgerAccountRefs: [],
            journalEntryDrafts: [],
            ledgerAccountRefNo: '',
            ledgerAccountName: '',
            addNewRow: 'selectRows',
            credit: '',
            debit: '',
            description: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),
            records: [
                { ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' },
                { ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' }
            ],
            journalEntries: [],
            transactionView: [],
            open: false,

            narration: '',
            draftId: 0,
        };

        this.populateData();

        this.handleRecordLedgerAccRefChange = this.handleRecordLedgerAccRefChange.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
    }



    populateData() {
        this.getLedgerAccounts();
        this.getJournalEntries(null, null);
        this.getJournalEntryDrafts();
    }

    getLedgerAccounts() {
        console.log('getting ledger accounts...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails');
        request.then((response) => {


            if (!response.data.error && response.data.success && response.data.ledgerAccountDetails) {
                console.log('ledger accounts recieved', response.data);
                var ledgerAccounts = [];
                var ledgerAccountNames = [];
                var ledgerAccountRefs = [];
                for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {
                    ledgerAccounts.push(
                        {
                            ID_LEDGER_ACCOUNT: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            NAME: response.data.ledgerAccountDetails[i].NAME,
                            LEDGER_REF_NO: response.data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                    ledgerAccountNames.push(
                        {
                            value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: response.data.ledgerAccountDetails[i].NAME
                        }
                    );
                    ledgerAccountRefs.push(
                        {
                            value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: response.data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                }
                this.setState(
                    {
                        ledgerAccounts: ledgerAccounts,
                        ledgerAccountNames: ledgerAccountNames,
                        ledgerAccountRefs: ledgerAccountRefs
                    }
                );

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('error', error);
                this.setState({ loading: false });
            });
    }

    getJournalEntryDrafts() {
        console.log('getting journal entry drafts...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/journalEntry/getJournalEntryDraftsAll');
        request.then((response) => {


            if (!response.data.error && response.data.success && response.data.journalEntryDrafts) {
                console.log('journal entry drafts recieved', response.data);

                this.setState(
                    {
                        journalEntryDrafts: response.data.journalEntryDrafts
                    }
                );

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('error', error);
                this.setState({ loading: false });
            });
    }

    getJournalEntries(from, to) {
        console.log('getting journal entries...');

        this.setState({ loading: true });
        var body = {
            from: from,
            to: to
        };

        const request = axios.post(window.accountServer + '/journalEntry/getJournalEntries', body);
        request.then((response) => {
            if (!response.data.error && response.data.success && response.data.journalEntries) {
                console.log('journal entries recieved', response.data);
                this.setState({ journalEntries: response.data.journalEntries });
                this.setState({ loading: false });
            }
            else {
                console.log('not successful', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('error', error);
                this.setState({ loading: false });
            });

    }

    loadDraft(id) {
        console.log(id);
        this.setState({ loading: true });
        var body = {
            id: id
        };

        const request = axios.post(window.accountServer + '/journalEntry/getJournalEntryDraftById', body);
        request.then((response) => {
            if (!response.data.error && response.data.success) {

                console.log('journal entry draft', response.data);
                let resObject = JSON.parse(response.data.journalEntryDraft.DATA_OBJECT);
                console.log('resObject', resObject)
                var daten = (response.data.journalEntryDraft.DATE).split("T")[0]
                var tdate = (response.data.journalEntryDraft.TRANSACTION_DATE).split("T")[0];

                this.setState({
                    draftId: id,
                    date: daten,
                    transactionDate: tdate,
                    documentNumber: response.data.journalEntryDraft.DOCUMENT_NO,
                    journalNumber: response.data.journalEntryDraft.JOURNAL_NO,
                    narration: response.data.journalEntryDraft.NARRATION,
                    // date: response.data.journalEntryDraft.DATE,
                    records: resObject
                });

                this.setState({ loading: false });
            }
            else {
                console.log('load journal entry draft not successful', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('load journal entry draft error', error);
                this.setState({ loading: false });
            });
    }

    saveDraft() {
        this.setState({ loading: true });
        let dataObject = JSON.stringify(this.state.records);
        var body = {
            date: this.state.date,
            documentNumber: this.state.documentNumber,
            transactionDate: this.state.transactionDate,
            journalNumber: this.state.journalNumber,
            narration: this.state.narration,
            dataObject: dataObject
        };

        const request = axios.post(window.accountServer + '/journalEntry/saveJournalEntryDraft', body);
        request.then((response) => {
            if (!response.data.error && response.data.success) {
                console.log('saveJournalEntryDraft', response.data);
                this.setState({ loading: false });
                this.props.alert.success('Draft Saved');
                this.handleClear();
                this.populateData();
            }
            else {
                console.log('save journal entry draft not successful', response.data);
                this.setState({ loading: false });
                this.props.alert.error('Draft Save Failed');
            }
        })
            .catch((error) => {
                console.log('save journal entry draft error', error);
                this.setState({ loading: false });
                this.props.alert.error('Draft Save Failed');
            });
    }

    handleSelectChange = name => event => {
        var value = event.target.value;
        const row = { ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' };
        if (name == 'addNewRow') {
            var records = [...this.state.records];
            var newRecords = [];
            if (value == 5) {
                let rows = [Object.assign({}, row), Object.assign({}, row), Object.assign({}, row), Object.assign({}, row), Object.assign({}, row)];
                newRecords = records.concat(rows);
            } else if (value == 1) {
                newRecords = records.concat(Object.assign({}, row));
            }
            this.setState({ addNewRow: 'selectRows', records: newRecords });
        }
    };

    handleRecordTextBoxChange = (name, i) => event => {
        var value = event.target.value;
        var records = [...this.state.records];
        if (name == 'credit' || name == 'debit') {
            value = !isNaN(value) ? value : records[i][name];
        }
        records[i][name] = value;
        this.setState(
            { records: records }
        );
    };

    handleRecordLedgerAccRefChange = index => selectedOption => {
        var records = [...this.state.records];

        console.log('records', records);
        console.log('index', index);
        console.log('selectedOption', selectedOption);

        if (selectedOption) {
            records[index].ledgerAccountName = selectedOption.value;
            records[index].ledgerAccountRefNo = selectedOption.value;
            this.setState({ records: records });
        }
        else {
            records[index].ledgerAccountName = '';
            records[index].ledgerAccountRefNo = '';
            this.setState({ records: records });
        }
    }

    removeRecord = index => {
        if (this.state.records.length == 1) {
            this.setState({ records: [{ ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' }] });
        }
        else {
            var records = [...this.state.records];
            records.splice(index, 1)
            this.setState({ records: records });
        }

    }

    getDebitBalance() {
        var records = this.state.records;
        var totalDebit = 0;
        for (let i = 0; i < records.length; i++) {
            if (records[i].debit != '' && records[i].debit != null && records[i].debit != undefined) {
                totalDebit = parseFloat(totalDebit) + parseFloat(records[i].debit);
            }
        }
        return parseFloat(totalDebit).toFixed(2);
    }

    getCreditBalance() {
        var records = this.state.records;
        var totalCredit = 0;
        for (let i = 0; i < records.length; i++) {
            if (records[i].credit != '' && records[i].credit != null && records[i].credit != undefined) {
                totalCredit = parseFloat(totalCredit) + parseFloat(records[i].credit);
            }
        }
        return parseFloat(totalCredit).toFixed(2);
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    validateTransactions() {
        for (let i = 0; i < this.state.records.length; i++) {
            if (this.state.records[i].ledgerAccountName == '') {
                this.props.alert.error('Remove empty rows');
                return;
            }
        }
    }

    handleSaveClick() {
        if (!this.areRecordsValid()) {
            confirmAlert({
                title: 'Invalid Records', message: 'Please remove unused rows or use all the rows',
                buttons: [{ label: 'Ok' }]
            })
            return;
        }

        const url = window.accountServer + "/journalEntry/createJournal";
        var body = {
            DATE: this.state.date,
            DOCUMENT_NO: this.state.documentNumber,
            TRANSACTION_DATE: this.state.transactionDate,
            JOURNAL_NO: this.state.journalNumber,
            NARRATION: this.state.narration,
            IS_ACTIVE: 1
        };

        this.setState({ loading: true });

        const request = axios.post(url, body);
        request.then((response) => {
            console.log('response', response);
            if (response.data && response.data.success) {

                // delete draft details <<sheyan>>
                if (0 != this.state.draftId) {
                    axios.post(window.accountServer + '/journalEntry/deleteJournalEntryDraftById', { id: this.state.draftId })
                        .then(response3 => {
                            console.log(response3)
                            if (response3.data.success) {
                                const request = axios.get(window.accountServer + '/journalEntry/getJournalEntryDraftsAll');
                                request.then((response) => {


                                    if (!response.data.error && response.data.success && response.data.journalEntryDrafts) {
                                        console.log('journal entry drafts recieved', response.data);

                                        this.setState(
                                            {
                                                journalEntryDrafts: response.data.journalEntryDrafts
                                            }
                                        );
                                    }
                                    else {
                                        console.log('error', response.data);
                                        this.setState({ loading: false });
                                    }
                                })
                                    .catch((error) => {
                                        console.log('error', error);
                                        this.setState({ loading: false });
                                    });
                            }

                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                        });
                }

                const journalId = response.data.insertId;

                var transactionLedgerHeader = {
                    TANSACTION_TYPE: 'JOURNAL',
                    DATE: this.state.transactionDate,
                    REFERENCE_ID: journalId,
                    IS_ACTIVE: 1
                };

                var records = this.state.records;
                var transactionLedgerDetails = [];
                for (let i = 0; i < records.length; i++) {
                    let item = [records[i].ledgerAccountName, null, records[i].description, records[i].credit, records[i].debit, null, null, 1, null];
                    transactionLedgerDetails.push(item);
                }

                const url2 = window.accountServer + "/transactionLedger/bulkInsert";
                const body2 = {
                    transactionLedgerHeader: transactionLedgerHeader,
                    transactionLedgerDetails: transactionLedgerDetails
                }

                console.log('transactionLedgerDetails', transactionLedgerDetails);

                const request2 = axios.post(url2, body2);
                request2.then((response2) => {
                    console.log('response2', response2);

                    if (response2.data && response2.data.success) {
                        this.props.alert.success('Journal Entry Added');

                        axios.post(window.reportServer + '/journalReport/getJournalPopUpReport', { transactionHeaderId: response2.data.transaction_header_id })
                            .then(response3 => {
                                console.log(response3)
                                if (response3.data.success) {
                                    var address = response3.data.path;
                                    address = window.reportServer + "/" + address;
                                    // address = "http://localhost:2008/" + address;

                                    printjs({ printable: address, type: 'pdf', showModal: true })
                                    //console.log("done..");
                                }
                                this.clearValue()
                            }).catch(function (error) {
                                console.log("err " + error);
                                console.log("No internet connection or Internal error");
                            });



                        this.handleClear();
                        this.setState({ loading: false },
                            () => {
                                this.getJournalEntries(null, null);
                            });
                    }
                    else {
                        console.log('journal entry transactions data error', response2)
                        this.props.alert.success('Create Journal Entry Failed');
                        this.setState({ loading: false });
                    }
                })
                    .catch((error) => {
                        this.props.alert.error('Create Journal Entry Failed');
                        console.log('journal entry transactions error', error)
                        this.setState({ loading: false });
                    });

            }
            else {
                console.log('journal entry data error', response.data)
                this.props.alert.success('Create Journal Entry Failed');
                this.setState({ loading: false });

            }
        })
            .catch((error) => {
                this.setState({ loading: false });
                this.props.alert.error('Create Journal Entry Failed');
                console.log('journal entry error', error)
            });
    }

    handleClear() {
        this.setState({
            records: [{ ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' },
            { ledgerAccountRefNo: '', ledgerAccountName: '', description: '', debit: '', credit: '' }]
        });
        this.setState({
            ledgerAccountName: '',
            ledgerAccountRefNo: '',
            journalNumber: '',
            documentNumber: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),
            narration: ''
        });
    }

    areRecordsValid() {
        for (let i = 0; i < this.state.records.length; i++) {
            if (this.state.records[i].ledgerAccountRefNo == '') {
                return false;
            }
            else if (this.state.records[i].debit == '' && this.state.records[i].credit == '') {
                return false;
            }
        }
        return true;
    }

    handleView(journalId) {
        this.setState({ loading: true });
        const url = window.accountServer + "/transactionLedger/getJournalTransactions";
        var body = {
            ID_JOURNAL_ENTRY: journalId
        };


        const request = axios.post(url, body);
        request.then((response) => {
            console.log('getJournalTransactions', response);
            if (!response.data.error && response.data.success && response.data.ledgerTransactions) {
                this.setState({
                    transactionView: response.data.ledgerTransactions,
                    openDialog: true,
                    loading: false
                });
            } else {
                console.log('getJournalTransactions not successful', response.data)
                this.props.alert.success('Failed to get transaction data');
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('getJournalTransactions error', error)
                this.props.alert.success('Failed to get transaction data');
                this.setState({ loading: false });
            });

    }

    handleDialogClose() {
        this.setState({
            openDialog: false
        });
    }

    componentWillMount() { }

    render() {
        const { selectedDay } = this.state;
        const parseDate = '2018-06-06';

        var blockStyle = { display: 'block', margin: 0 };

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        const { classes } = this.props;

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="px-16">
                    <div className="p-8">
                        <h2 className="subtitle-color subtitle-margin-journal-entry invoice-margin">Journal Entries</h2>
                    </div>

                    <div className=" block">

                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                            <TextField
                                id="name"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                label="Date"
                                placeholder=""
                                type="date"
                                value={this.state.date}
                                onChange={this.handleTextBoxChange('date')}
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-1/5 p-8  inline-block">
                            <TextField
                                id="transactionDate"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                label="Transaction Date"
                                placeholder=""
                                type="date"
                                value={this.state.transactionDate}
                                onChange={this.handleTextBoxChange('transactionDate')}
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                            <TextField
                                id="name"
                                label="Document Number"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                value={this.state.documentNumber}
                                onChange={this.handleTextBoxChange('documentNumber')}
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-2/5 p-8  inline-block">
                            <ReactTable
                                getTrProps={(state, rowInfo, column) => {
                                    return {
                                        className: "cursor-pointer",
                                        onClick: (e, handleOriginal) => {
                                            this.loadDraft(rowInfo.original.ID_JOURNAL_ENTRY_DRAFT);
                                        }
                                    }
                                }}
                                data={this.state.journalEntryDrafts}
                                columns={[

                                    {
                                        Header: "Date",
                                        accessor: "DATE",
                                        filterable: true,
                                        Cell: row => (
                                            <div>
                                                {moment(new Date(row.original.DATE)).format("YYYY-MM-DD")}
                                            </div>
                                        )
                                    },
                                    {
                                        Header: "Journal Number",
                                        accessor: "JOURNAL_NO",
                                        filterable: true
                                    },
                                    /* {
                                        Header: "Reference Number",
                                        accessor: "REFERENCE_NO",
                                        filterable : true
                                    }, */
                                    {
                                        Header: "Narration",
                                        accessor: "NARRATION",
                                        filterable: true
                                    }/* ,
                                    {
                                        Header: "Action",
                                        width: 128,
                                        Cell: row => (
                                            <div>
                                                <Button
                                                    variant="raised"
                                                    color="secondary"
                                                    className={classes.button}
                                                    aria-label="View"
                                                    disabled={false}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleView(row.original.ID_JOURNAL_ENTRY);
                                                    }}
                                                >
                                                    View
                                                </Button>       
                                            </div>
                                        )
                                    } */
                                ]}
                                //pageSize={this.state.records.length>3?this.state.records.length:3}
                                defaultPageSize={2}
                                className="-striped -highlight"
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-1/5 p-8  inline-block journal-entry-feild-margin">
                            <TextField
                                id="journalNumber"
                                label="Journal Number"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                value={this.state.journalNumber}
                                onChange={this.handleTextBoxChange('journalNumber')}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8  inline-block journal-entry-feild-margin">
                            <TextField
                                id="narration"
                                label="Narration"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}

                                value={this.state.narration}
                                onChange={this.handleTextBoxChange('narration')}
                            />
                        </div>

                    </div>

                    <div className="w-full mt-20" align="center">
                        <table>
                            <tr>
                                <th className="w-1/6 px-8">Account No</th>
                                <th className="w-1/6 px-8">Account Name</th>
                                <th className="w-1/6 px-8">Description</th>
                                <th className="w-1/6 px-8">Debit</th>
                                <th className="w-1/6 px-8">Credit</th>
                                <th className="w-1/6 px-8"></th>
                            </tr>
                            {this.state.records.map((item, i) => {
                                return (<tr>
                                    <td className="w-1/6 px-8">
                                        <div className="w-full">
                                            <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Select Ledger Account"
                                                value={this.state.records[i].ledgerAccountRefNo}
                                                onChange={this.handleRecordLedgerAccRefChange(i)}
                                                options={this.state.ledgerAccountRefs}
                                            />
                                        </div>
                                    </td>
                                    <td className="w-1/6 px-8">
                                        <div className="w-full">
                                            <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Select Ledger Account"
                                                value={this.state.records[i].ledgerAccountName}
                                                onChange={this.handleRecordLedgerAccRefChange(i)}
                                                options={this.state.ledgerAccountNames}
                                            />
                                        </div>
                                    </td>
                                    <td className="w-1/6 px-8">
                                        <div className="w-full">
                                            <TextField
                                                className=""
                                                id="description"
                                                value={this.state.records[i].description}
                                                className={classes.textField}
                                                onChange={this.handleRecordTextBoxChange('description', i)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td className="w-1/6 px-8">
                                        <div className="w-full">
                                            {/* <TextField
                                               className="block"
                                               id="description"
                                               value={this.state.records[i].debit}
                                               className={classes.textField}
                                               onChange={this.handleRecordTextBoxChange('debit',i)}
                                               inputStyle={{ textAlign: 'center'}}
                                               InputLabelProps={{
                                                   shrink: true,
                                               }}
                                           /> */}
                                            <Input
                                                label={null}
                                                className="inline-block"
                                                classes={{
                                                    input: classes.input
                                                }}
                                                //style = {{width:'100px',textAlign: 'center'}}
                                                id="input-quantity"
                                                disabled={this.state.records[i].credit != ''}
                                                value={this.state.records[i].debit}
                                                //hintStyle={{ width: '100px', textAlign: 'center' }}
                                                onChange={this.handleRecordTextBoxChange('debit', i)}
                                            />
                                        </div>
                                    </td>
                                    <td className="w-1/6 px-8">
                                        <div className="w-full">
                                            {/* <TextField
                                               className="block"
                                               id="credit"
                                               value={this.state.records[i].credit}
                                               className={classes.textField}
                                               onChange={this.handleRecordTextBoxChange('credit',i)}
                                               InputLabelProps={{
                                                   shrink: true,
                                               }}
                                           /> */}
                                            <Input
                                                label={null}
                                                className="inline-block"
                                                classes={{
                                                    input: classes.input
                                                }}
                                                disabled={this.state.records[i].debit != ''}
                                                id="input-quantity"
                                                value={this.state.records[i].credit}
                                                onChange={this.handleRecordTextBoxChange('credit', i)}
                                            />
                                        </div>
                                    </td>
                                    <td className="sm:w-1/2 md:w-1/5 px-8">
                                        <div className="w-full px-8">
                                            <IconButton
                                                className={classes.smaller}
                                                title="Remove"
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.removeRecord(i);
                                                }}

                                            >
                                                <Icon className='text-red'>cancel</Icon>
                                            </IconButton>
                                        </div>
                                    </td>


                                </tr>);
                            })}

                            <tr>
                                <td className="w-1/6 px-8">
                                    <div className="w-full">
                                        <MSelect
                                            className="w-full sm:1/2"
                                            label="Payment Term"
                                            value={this.state.addNewRow}
                                            onChange={this.handleSelectChange('addNewRow')}
                                            inputProps={{
                                                name: 'addNewRow',
                                                id: 'addNewRow',
                                            }}
                                        >
                                            <MenuItem className="popup-value-size" value="selectRows">Add Rows</MenuItem>
                                            <MenuItem className="popup-value-size" value="1">1 row</MenuItem>
                                            <MenuItem className="popup-value-size" value="5">5 rows</MenuItem>
                                        </MSelect>
                                    </div>
                                </td>
                                <td className="w-1/6 px-8"> </td>

                                <td className="w-1/6 px-8"> </td>
                                <td className="w-1/6 px-8">
                                    <div align="right" className="w-full">
                                        {this.getDebitBalance()}
                                    </div>
                                </td>
                                <td className="w-1/6 px-8">
                                    <div align="right" className="w-full">
                                        {this.getCreditBalance()}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="w-1/6 px-8"> </td>
                                <td className="w-1/6 px-8"> </td>
                                <td className="w-1/6 px-8"> </td>
                                <td className="w-1/6 px-8">
                                    <div align="right" className="w-full">
                                        <strong>Balance</strong>
                                    </div>
                                </td>
                                <td className="w-1/6 px-8">
                                    <div className="w-full">
                                        <div align="right" className="w-full">
                                            {(parseFloat(this.getDebitBalance()) - parseFloat(this.getCreditBalance())).toFixed(2)}
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </table>
                    </div>

                    <div align="right" className="w-full mt-16">
                        <div className="mx-8 inline-block">
                            <Button
                                variant="raised"
                                color="secondary"
                                className={classes.button}
                                aria-label="Save"
                                disabled={(parseFloat(this.getDebitBalance()) - parseFloat(this.getCreditBalance())).toFixed(2) != 0}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.handleSaveClick();
                                }}
                            >
                                Save
                            </Button>
                        </div>
                        <div className="mx-8 inline-block">
                            <Button
                                variant="raised"
                                color="primary"
                                className={classes.button}
                                aria-label="Draft"
                                disabled={false}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.saveDraft();

                                }}
                            >
                                Draft
                            </Button>
                        </div>
                        <div className="mx-8 inline-block">
                            <Button
                                variant="raised"
                                color="primary"
                                className={classes.button}
                                aria-label="Clear"
                                disabled={false}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.handleClear();
                                }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                    <div className="mt-16 px-8">
                        <ReactTable
                            data={this.state.journalEntries}
                            columns={[

                                {
                                    Header: "Date",
                                    accessor: "DATE",
                                    filterable: true,
                                    Cell: row => (
                                        <div>
                                            {moment(new Date(row.original.DATE)).format("YYYY-MM-DD")}
                                        </div>
                                    )
                                },
                                {
                                    Header: "Journal Number",
                                    accessor: "JOURNAL_NO",
                                    filterable: true
                                },
                                {
                                    Header: "Document Number",
                                    accessor: "DOCUMENT_NO",
                                    filterable: true
                                },
                                {
                                    Header: "Narration",
                                    accessor: "NARRATION",
                                    filterable: true
                                },
                                {
                                    Header: "Action",
                                    width: 128,
                                    Cell: row => (
                                        <div>
                                            <Button
                                                variant="raised"
                                                color="secondary"
                                                className={classes.button}
                                                aria-label="View"
                                                disabled={false}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleView(row.original.ID_JOURNAL_ENTRY);
                                                }}
                                            >
                                                View
                                                </Button>
                                        </div>
                                    )
                                }
                            ]}
                            //pageSize={this.state.records.length>3?this.state.records.length:3}
                            defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>

                    <Dialog open={this.state.openDialog} onClose={this.handleDialogClose} aria-labelledby="form-dialog-title" fullScreen >
                        <AppBar className="flex w-full app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Journal Entry Records
                          </Typography>
                                <IconButton className="" color="inherit" onClick={this.handleDialogClose} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <DialogContent>
                            <div className="journal-entry-popup-margin">

                                <ReactTable
                                    data={this.state.transactionView}
                                    columns={[

                                        {
                                            Header: "Account Name",
                                            accessor: "NAME",
                                            filterable: true
                                        },
                                        {
                                            Header: "Account Ref Number",
                                            accessor: "LEDGER_REF_NO",
                                            filterable: true
                                        },
                                        {
                                            Header: "CR",
                                            accessor: "CR",
                                            filterable: true
                                        },
                                        {
                                            Header: "DR",
                                            accessor: "DR",
                                            filterable: true
                                        },
                                        {
                                            Header: "Description",
                                            accessor: "DESCRIPTION",
                                            filterable: true
                                        }
                                    ]}
                                    //pageSize={this.state.records.length>3?this.state.records.length:3}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />


                                <div className="jurnal-entry-close-btn max-w-256 p-20">
                                    <Button
                                        color="primary"
                                        variant="raised"
                                        className="mx-auto mt-16"
                                        onClick={
                                            (ev) => {
                                                ev.stopPropagation();
                                                this.handleDialogClose();
                                            }
                                        }
                                    >
                                        Close
                                        </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
            )


        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(JournalEntry));


// WEBPACK FOOTER //
// ./src/main/content/accounting/journalEntry/JournalEntry.js